export const gpioHeaderTemplate = 
`
/* USER CODE GEN */
/**
  ******************************************************************************
  * @file    gpio.h
  * @brief   This file contains all the function prototypes for
  *          the gpio.c file
  ******************************************************************************
  */
/* USER CODE END Header */
/* Define to prevent recursive inclusion -------------------------------------*/
#ifndef __GPIO_H__
#define __GPIO_H__

#ifdef __cplusplus
extern "C" {
#endif

#include "Bosc32fxx.h"

void mx_gpio_init(void); 

#ifdef __cplusplus
}
#endif
#endif /*__ GPIO_H__ */
`;



export const gpioSourceTemplate = 
`
#include "driver_gpio.h"
#include "driver_pinmux.h"
/*!
    \\brief      user gpio configure function
    \\param[in]  none
    \\param[out] none
    \\retval     none
*/ 
void mx_gpio_init(void)
{
    {pinsCode}
}
`;

export const gpioOutputTemplate = 
`
    pmx_gpio_config({name}, {GPIOx}, {GPIO_Pin}, {GPIO_ModeDefaultOutputPP});

    /* configure  {GPIO_Pin}  */
    gpio_mode_set({name}, {GPIO_Mode},  {GPIO_PullupPulldown}, {GPIO_Pin});
    gpio_output_options_set({GPIOx}, {GPIO_ModeDefaultOutputPP}, {GPIO_Speed}, {GPIO_Pin});
    gpio_set_level({GPIOx}, {GPIO_Pin}, {PinState});
`;

export const gpioInputTemplate = 
`
    /* configure button pin as input */
    pmx_gpio_config({name}, {GPIOx},  {GPIO_Pin}, {GPIO_Mode});
    gpio_mode_set({GPIOx}, {GPIO_Mode}, {GPIO_PullupPulldown}, {GPIO_Pin});
`;

